import {
  IconCircle,
  PictureViewerDS,
  RemoveRedEyeOutlined,
  SpinnerDS,
  TextCapitalized,
} from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import type { QueryStatus } from "../../../../../utils";
import type { VehicleRestitutionPictures } from "../../fleetApi";
import "../../../../../i18n/i18n";

export const RestitutionPictures = (props: {
  pictures: VehicleRestitutionPictures | null;
  picturesStatus: QueryStatus | null;
}) => {
  const { pictures, picturesStatus } = props;
  const { t } = useTranslation();

  if (picturesStatus === "failed") {
    return (
      <StyledEmpty>
        <TextCapitalized>
          {t("fleet.vehicleSessions.sidepanel.state.picturesError")}
        </TextCapitalized>
      </StyledEmpty>
    );
  }

  if (
    !pictures &&
    (picturesStatus === "idle" || picturesStatus === "processing")
  ) {
    return (
      <StyledLoader>
        <SpinnerDS />
      </StyledLoader>
    );
  }

  if (pictures && pictures.length > 0) {
    return (
      <StyledGrid>
        {pictures.map((picture) => (
          <PictureViewerDS
            key={picture.uuid}
            url={picture.url}
            icon={
              <IconCircle
                icon={<RemoveRedEyeOutlined />}
                iconColor={"textBlack"}
                backgroundColor={"textWhite"}
                size={"S"}
              />
            }
          />
        ))}
      </StyledGrid>
    );
  }

  return (
    <StyledEmpty>
      <TextCapitalized>
        {t("fleet.vehicleSessions.sidepanel.state.noPictures")}
      </TextCapitalized>
    </StyledEmpty>
  );
};

const StyledLoader = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const StyledEmpty = styled.div`
  ${typographies["Body/S"]}
  color: ${colors["colors/text/lightGrey"]};
`;

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
`;
